
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 26 21.667"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"a",attrs:{"d":"M5.2 0a2.517 2.517 0 00-2.6 2.407 2.363 2.363 0 001.056 1.926H1.04A.97.97 0 000 5.3v4.33a.97.97 0 001.04.963h23.92A.97.97 0 0026 9.63V5.3a.97.97 0 00-1.04-.963h-2.616a2.363 2.363 0 001.056-1.93 2.608 2.608 0 00-5.2 0 2.363 2.363 0 001.056 1.926H6.744A2.363 2.363 0 007.8 2.407 2.517 2.517 0 005.2 0zm0 .963a1.5 1.5 0 011.56 1.444A1.5 1.5 0 015.2 3.852a1.5 1.5 0 01-1.56-1.445A1.5 1.5 0 015.2.963zm15.6 0a1.5 1.5 0 011.56 1.444 1.565 1.565 0 01-3.12 0A1.5 1.5 0 0120.8.963zM1.04 5.3h2.519L1.04 9.223zm6.841 0h2.957l-2.81 4.33H5.086zm7.28 0h2.958l-2.812 4.33h-2.941zm7.28 0h2.519v.752c-.018.019-.035.023-.049.045L22.636 9.63H19.63zM2.08 11.074v10.111a.5.5 0 00.52.481h2.6a.5.5 0 00.52-.481V11.074zm18.2 0v10.111a.5.5 0 00.52.481h2.6a.5.5 0 00.52-.481V11.074zM6.76 15.889v2.889h12.48v-2.889z"}})])
          )
        }
      }
    